import { useState, useCallback, useMemo } from 'react';
import { Student } from '@/types';

export const useTableSearch = (students: Student[]) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = useCallback((query: string) => {
    setSearchQuery(query.toLowerCase());
  }, []);

  const filteredStudents = useMemo(() => {
    if (!searchQuery.trim()) return students;

    return students.filter(student => {
      const fullName = `${student.firstName} ${student.lastName}`.toLowerCase();
      const id = student.id.toLowerCase();
      const grade = `grade ${student.grade}`.toLowerCase();
      
      return (
        fullName.includes(searchQuery) ||
        id.includes(searchQuery) ||
        grade.includes(searchQuery)
      );
    });
  }, [students, searchQuery]);

  return {
    searchQuery,
    handleSearch,
    filteredStudents
  };
};